import { Location } from "components/BillingLocationSelector";
import { Basis, Positions, Requirements, PositionId, BasisId, RequirementId } from "./config";

export enum EditPostMode {
    post = "post",
    edit = "edit",
    repost = "repost"
}

export type SelectOption = {
    id: number,
    text: string
};

export type EditedJob = {
    id?: number
    position?: typeof Positions[number],
    basis?: typeof Basis[number],
    location?: Location
    availability?: SevenBinaryArray
    startDate?: Date
    endDate?: Date
    // used to change default dates for jobs being reposted
    datesAutoEdited?: boolean
    approxStart?: boolean
    approxEnd?: boolean
    requirement?: typeof Requirements[number]
    title?: string
    description?: string
    notificationEmail?: string
    isOrtho?: boolean
    isRestorative?: boolean
    isPublic: boolean
    status?: number
    changed?:boolean
    /** If true, attempt to enable Featured Listing right after posting */
    featureOnPost?: boolean
}

export type BinaryDigitString = "0" | "1";
export type BinaryDigitNum = 0 | 1;
export type SevenBinaryDigitsString = `${BinaryDigitString},${BinaryDigitString},${BinaryDigitString},${BinaryDigitString},${BinaryDigitString},${BinaryDigitString},${BinaryDigitString}`;
export type SevenBinaryArray = [
  BinaryDigitNum,
  BinaryDigitNum,
  BinaryDigitNum,
  BinaryDigitNum,
  BinaryDigitNum,
  BinaryDigitNum,
  BinaryDigitNum
];

export type BackendJob = {
    id?: number
    locationId?: number
    title?: string
    description?: string
    startDate?: string
    endDate?: string
    jobType?: (typeof Positions[number])['id']
    basis?: (typeof Basis[number])['id']
    daysOfWeek?: SevenBinaryDigitsString
    sendEmailTo?: string
    minYearsExp?: (typeof Requirements[number])['id']
    approxStart?: boolean
    approxEnd?: boolean
    newCandidates?: number
    location_address?: string
    location_province?: string
    location_city?: string
    status?: number
    position?: string
    isApplied?: number
    applicationId?: number
    isOrtho?: boolean
    isRestorative?: boolean
    freePeriod?: any
    createdOn?: string,
    total_applications?: number
    expires?: string
    isPublic: boolean
    publicUrl?: string | null
}

export type HireJobDTO = Pick<BackendJob, 
  "locationId" |
  "title" |
  "description" |
  "startDate" |
  "endDate" |
  "approxStart" |
  "approxEnd" |
  "jobType" |
  "basis" |
  "minYearsExp" |
  "daysOfWeek" |
  "sendEmailTo" |
  "isOrtho" |
  "isRestorative" |
  "isPublic"
>;

export type HygienistBackendJob = {
    id: number
    position: string
    jobType: PositionId
    basis?: BasisId
    title: string
    description: string
    sendEmailTo: string
    location: {
        practiceName: string
        lat: number
        lon: number
        province: string
        city: string
        phone: string
        email: string
        address: string
        isReliable: number,
        status: number,
        country: number
    }
    startDate?: string
    endDate?: string
    minYearsExp: RequirementId
    approxStart?: boolean
    approxEnd?: boolean
    daysOfWeek: SevenBinaryDigitsString
    isApplied: number
    applicationId?: number
    applicationStatus?: number
    distance: number,
    distanceObj: {
        distance: { text: string, value: number },
        duration: { text: string, value: number },
    }
    createdOn?: string;
    isPublic: boolean;
}

export type AiAssistResponses = {
    spellChecked?: string
    enhanced?: string
}

